//
export var PartnerLeadMapper = function (response) {
    return response;
};
